import dayjs from "dayjs"
import {
  LuUser, LuCreditCard, LuClipboardList,
  LuCalendarClock, LuFileCheck, LuCalculator,
} from "react-icons/lu"
import { now, dateToServer, getNextWorkingDay } from "../../../utils/date"

export const getTabs = ({ disableTabs }) => {
  return [
    {
      id: "basic-info",
      icon: LuUser,
      label: "Basic Info",
    },
    {
      id: "credit-select",
      icon: LuCreditCard,
      label: "Credit Select",
      disabled: disableTabs.creditSelect
    },
    {
      id: "program-plan",
      icon: LuClipboardList,
      label: "Program Plan",
      disabled: disableTabs.programPlan
    },
    {
      id: "payment-schedule",
      icon: LuCalendarClock,
      label: "Payment Schedule",
      disabled: disableTabs.paymentSchedule
    },
    {
      id: "review",
      icon: LuFileCheck,
      label: "Review",
      disabled: disableTabs.review
    },
    {
      id: "budget-calculator",
      icon: LuCalculator,
      label: "Budget Calculator",
    }
  ]
}

export const ACQUISITION_SOURCE_OPTIONS = [
  { label: 'Facebook Ads', value: 'Facebook Ads' },
  { label: 'Google Ads', value: 'Google Ads' },
  { label: 'TikTok', value: 'TikTok' },
  { label: 'Organic', value: 'Organic' },
  { label: 'Referral', value: 'Referral' },
  { label: 'Email Campaign', value: 'Email Campaign' },
]

export const LEGACY_LEAD_SOURCE_MAX_LENGTH = 30
export const LEAD_SOURCE_MAX_LENGTH = 50

export const userInfoInit = {
  firstName: "",
  lastName: "",
  middleName: "",
  primaryPhone: "",
  secondaryPhone: "",
  email: "",
  address: "",
  aptNumber: "",
  city: "",
  state: "",
  zip: "",
  gender: "",
  timeZone: "",
  dateOfBirth: '',
  enrollmentDate: dateToServer(now()),
  acquisitionSource: "",
}

export const programPlanInit = {
  programFee: 50,
  custodialFee: 50,
  plan: 18,
  amount: "",
  initialFee: ''
}

export const paymentScheduleInit = {
  frequency: "monthly",
  cycleStartDate: dayjs(),
  secondDate: null,
  tableData: [],
  paymentDays: [],
  startFromMonth: null
}

export const disableTabsInit = {
  creditSelect: true,
  programPlan: true,
  paymentSchedule: true,
  review: true
}

export const getPostData = ({ programPlan, paymentSchedule, calculatorItems }) => {
  return {
    programPlan: {
      programLength: programPlan?.plan,
      programFee: programPlan?.programFee,
      custodialFee: programPlan?.custodialFee,
    },
    paymentSchedule: {
      frequency: paymentSchedule?.frequency,
      startDate: dateToServer(paymentSchedule?.cycleStartDate),
      secondStartDate: dateToServer(paymentSchedule?.secondDate),
    },
    budgetCalculator: calculatorItems?.map(item => {
      const newItem = { ...item, amount: Number(item.value) }
      delete newItem.id
      return newItem
    })
  }
}
